import dispatcher from '../dispatcher';
import {EventEmitter} from '../utils';


let eventEmitter = new EventEmitter();


let active = false;
let initialized = false;

function _handleEvent(e) {
  switch (e.type) {
    case ('popup-toggle') :
      active = active === e.id ? false : e.id;

      eventEmitter.dispatch(_getData('change'));
      break;
    case ('popup-open') :
      if (active === e.id) return;
      active = e.id;

      eventEmitter.dispatch(_getData('change'));
      break;
    case ('popup-close') :
      if (!active) return;
      active = false;

      eventEmitter.dispatch(_getData('change'));
      break;
    case ('popup-close-all') :
    case ('mutate') :
      if (!active) return;
      active = false;

      eventEmitter.dispatch(_getData('change'));
      break;
  }
}

function _add(el) {
  let id = el.id;

  if (!id) {
    console.warn('popup id is missing');
    return;
  }

  if (el.classList.contains('active')) {
    active = id;
  }
}




function _getData(type) {
  return {
    type: type,
    active: active
  }
}

function _init() {
  let popups = document.querySelectorAll('.popup');

  for (let i = popups.length - 1; i >= 0; i--) {
    _add(popups[i]);
  }

  dispatcher.subscribe(_handleEvent);
  initialized = true;
}

if (!initialized) _init();

export default {
  eventEmitter: eventEmitter,
  getData: _getData.bind(null, undefined)
};

